import { render } from "./wxShareCalculator.vue?vue&type=template&id=6422bd78&scoped=true"
import script from "./wxShareCalculator.vue?vue&type=script&lang=js"
export * from "./wxShareCalculator.vue?vue&type=script&lang=js"

import "./wxShareCalculator.vue?vue&type=style&index=0&id=6422bd78&lang=scss"
import "./wxShareCalculator.vue?vue&type=style&index=1&id=6422bd78&lang=scss&scoped=true"

import exportComponent from "F:\\webStorm workspace\\ujk_tangying\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6422bd78"]])

export default __exports__